import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    let timeoutId: number;
    let attempts = 0;
    const id = decodeURIComponent(hash.slice(1));

    const scrollToHash = () => {
      const element = document.getElementById(id);

      if (element) {
        element.scrollIntoView();
        return;
      }

      attempts += 1;
      if (attempts < 10) {
        timeoutId = window.setTimeout(scrollToHash, 100);
      }
    };

    scrollToHash();

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [hash, pathname]);

  return null;
}
